export default "__VITE_ASSET__BeKKpzZR__"